import React, { useEffect, useState } from 'react'
import { styled } from '@mui/system'
import { Link, useParams  } from "react-router-dom"
import './common.css'
import API_URL from '../common/Apiurl';
import SuccessMessage from '../common/Message';

function Editquiz(){
    const apiUrl = API_URL;
    const [items, setItems] = useState([]);
    const [industryitems, setIndustryitems] = useState([]);
    const [successMessages, setSuccessMessages] = useState([]);
    const viewId = useParams();
    const getquizId = viewId.quizid;

    // valuetosend
    const [answer,setAnswer]=useState([]);
    const [question,setQuestion]=useState([]);
    const [fromtype, setFromtype]=useState([]);
    const [answertype, setAnswertype]=useState([]);
    const [options, setOptions]=useState([]);
    const [fromvalue, setFromvalue]=useState([]);
    const [tovalue, setTovalue]=useState([]);
    const [questionOrder, setQuestionOrder]=useState([]);
    const [selectedOptions, setSelectedOptions]=useState([]);
    const [optiontype, setOptiontype] = useState([]);
    const [answeroption, setAnsweroption] = useState([]);
    const [getAnswertype, setGetAnswertype]=useState([]);
    const [timeoption, setTimeoption] = useState([]);
    const [usertype, setUsertype]=useState([]);
    // valuetosend

    useEffect(() => {
        const getComments = async () => {
          try{
            const postData = {
                quizId: getquizId
            };
            const res = await fetch(`${apiUrl}/admin/getquizdetails`,{
                method:'POST',
                headers:{
                    "Content-Type":"application/json",
                    "Accept":"application/json"
                },
                body:JSON.stringify(postData)
            });
            const data = await res.json();
            if(data.status !== 200){
              throw new Error('Data not found');
            }
            const dataanswerType = data.data.answer_type;
            const datavalType = data.data.options;
            setItems(data.data);
            // setvalue
            setQuestion(data.data.text);
            setAnswer(data.data.answer);
            setFromtype(data.data.type);
            setUsertype(data.data.user_type);
            setAnswertype(data.data.answer_type);
            setGetAnswertype(data.data.answer_type);
            setQuestionOrder(data.data.order);
            setSelectedOptions(data.industryId);
            setOptions(data.data.options);
            setAnsweroption(data.data.options);
            setTimeoption(data.data.options);         
            // setvalue
            setIndustryitems(data.allIndustry);
            var answerOption='';
            if(dataanswerType == "options"){
                setOptions(datavalType);
                answerOption = 
                <div>
                    <span>Enter Options with comma separated</span>
                    <div className="col-sm-8 mt-3">
                        <input type="text" className="form-control" onChange={(e)=>setOptions(e.target.value)}/>
                    </div>
                    <span className='d-block mt-3'>{datavalType}</span>
                </div>          
                setOptiontype(answerOption); 
            }
            else if(dataanswerType == "time"){
                var answertimeVal = data.data.options.split('-');
                const arr1= answertimeVal[0].trim();
                const arr2= answertimeVal[1].trim();
                setFromvalue(arr1);
                setTovalue(arr2);
                answerOption = 
                <div>
                    From
                    <select className="form-select col-sm-2 selectBox mt-2 mb-2" onChange={(e)=>setFromvalue(e.target.value)}>
                        <option value={arr1}>{arr1.substring(0,2)}:{arr1.substring(2)}</option>
                        {timeOptions.map((time) => (
                            <option key={time} value={time}>
                                {`${time.substring(0,2)}:${time.substring(2)}`}
                            </option>
                        ))}
                    </select>
                    To
                    <select className="form-select col-sm-2 selectBox mt-2" onChange={(e)=>setTovalue(e.target.value)}>
                        <option value={arr2}>{arr2.substring(0,2)}:{arr2.substring(2)}</option>
                        {timeOptions.map((time) => (
                            <option key={time} value={time}>
                                {`${time.substring(0,2)}:${time.substring(2)}`}
                            </option>
                        ))}
                    </select>
                    {/* <span className='d-block mt-3'>{arr1}-{arr2}</span> */}
                </div>
                setOptiontype(answerOption); 
            }
          }catch(error){
            console.error('Error ', error)
          }
        };
        getComments();
      }, []);
      const timeOptions = [];
        for (let hour = 7; hour<=21; hour++){
            for (let minute = 0; minute<60; minute+=15){
                const formattedHour = hour.toString().padStart(2,0);
                const formattedMinute = minute.toString().padStart(2,0);
                const timeString = `${formattedHour}${formattedMinute}`;
                timeOptions.push(timeString);
            }
        }
      const Selectoptiontype = (e) => {
        var parseVal='';
        var getoptiontype = e.target.value;
        var answerOption = '';
        setAnswertype(getoptiontype);
       if(getoptiontype == "options"){
            var answerOption = 
            <div>
                <span>Enter Options with comma separated</span>
                <div className="col-sm-10 mt-3">
                    <input type="text" className="form-control" onChange={(e)=>setOptions(e.target.value)}/>
                </div>
                <span className='d-block mt-3'>{options}</span>
            </div>          
            setOptiontype(answerOption); 
        }
        else if(getoptiontype == "time"){
            var arr1= '';
            var arr2= '';
            if(getAnswertype === "time"){
                var answertimeVal = timeoption.split('-');
                arr1= answertimeVal[0].trim();
                arr2= answertimeVal[1].trim();
                setFromvalue(arr1);
                setTovalue(arr2);
            }
            answerOption = 
            <div>
                From
                <select className="form-select col-sm-2 selectBox mt-2 mb-2" onChange={(e)=>setFromvalue(e.target.value)}>
                    <option value={fromvalue}>{fromvalue.substring(0,2)}:{fromvalue.substring(2)}</option>
                    {timeOptions.map((time) => (
                        <option key={time} value={time}>
                            {`${time.substring(0,2)}:${time.substring(2)}`}
                        </option>
                    ))}
                </select>
                To
                <select className="form-select col-sm-2 selectBox mt-2" onChange={(e)=>setTovalue(e.target.value)}>
                    <option value={tovalue}>{tovalue.substring(0,2)}:{tovalue.substring(2)}</option>
                    {timeOptions.map((time) => (
                        <option key={time} value={time}>
                            {`${time.substring(0,2)}:${time.substring(2)}`}
                        </option>
                    ))}
                </select>
                {/* <span className='d-block mt-3'>{arr1}-{arr2}</span> */}
            </div>
            setOptiontype(answerOption); 
        }
        else{
            answerOption = '';
            setOptiontype(answerOption); 
        }
    }
    var enterValue = '';
    if(options != ''){
        enterValue = options
    }
    else if((fromvalue!='') && (tovalue!='')){
        enterValue = fromvalue+' - '+tovalue;
    }
    const updatequiz = async(e)=>{
        e.preventDefault();
        const postupdateData = {
            quizid:getquizId,
            industry_id:selectedOptions,
            from_type:fromtype,
            question:question,
            answer_type:answertype,
            enterValue:enterValue,
            questionOrder: questionOrder,
            user_type: usertype
        };
        console.log(postupdateData);
        try{
            const updateresult = await fetch(`${apiUrl}/admin/updatequiz`,{
                method:"POST",
                headers:{
                    "Content-Type":"application/json",
                    "Accept":"application/json"
                },
                body: JSON.stringify(postupdateData)
            })
            const data = await updateresult.json();
            if((data.status === 200)){
                const newSuccessMessage = data.message;
                setSuccessMessages([...successMessages, newSuccessMessage]);
            }else if((data.status === 400)){
                const newSuccessMessage = data.message;
                setSuccessMessages([...successMessages, newSuccessMessage]);
            }
        }
        catch(error){
            console.log("Error: ", error);
        }
    }
    const handleSuccessMessageFadeOut = () =>{
        setSuccessMessages((prevMessages) => prevMessages.slice(1));
        window.location.reload();
    }
    const handleOption = (e) =>{
        var getValue = (e.target.value);
        if(selectedOptions.includes(getValue)){
            setSelectedOptions(selectedOptions.filter((data)=>data!=getValue));
        }else{
            setSelectedOptions([...selectedOptions, getValue]);
        }
    }
    return (
        <div className='width90'>
            <h2 className='pageTitle'>Edit Question</h2>
            <div className='commonCntr'>
                <form className="form-horizontal" action="" onSubmit={updatequiz}>
                    <div className="form-group">
                        <label className="control-label col-sm-2 label">Industry:</label>
                        <select multiple className="form-select col-sm-5 selectBox" value={selectedOptions}  onChange={()=>{}}>
                            {industryitems.map((inditem) => {
                                return(<option value={inditem.industryId} onClick={handleOption}>{inditem.industry_name}</option>)
                                // <option value={inditem.industry_id}>{items.industryname}</option>
                            })}
                        </select>
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label">From Type:</label>
                        <select className="form-select col-sm-5 selectBox" value={fromtype} onChange={(e)=>setFromtype(e.target.value)} >
                            <option value="creator">Employer/Homeowner</option>
                            <option value="provider">Provider</option>
                        </select>
                    </div>
                    <div className="form-group mt-3">
                        <label className="control-label col-sm-2 label" htmlFor="options">User Type:</label>
                    </div> 
                    <select className="form-select col-sm-5 selectBox" value={usertype} onChange={(e)=>setUsertype(e.target.value)} >
                        <option value="">Select From type</option>
                        <option value="Provider">Provider</option>
                        <option value="Employer">Employer</option>
                        <option value="Homeowner">Homeowner</option>
                    </select>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label">Question:</label>
                        <div className="col-sm-5">
                            <input type="text" className="form-control" id="question" value={question} onChange={(e)=>setQuestion(e.target.value)} />
                        </div>
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label">Answer Type:</label>
                        <select className="form-select col-sm-5 selectBox" value={answertype} onChange={Selectoptiontype}>
                            <option value="yes_no">Yes/No</option>
                            <option value="options">Options</option>
                            {/* <option value="text">Textual Option</option> */}
                            <option value="numeric">Numeric Value</option>
                            <option value="time">Time</option>
                            {/* <option value="alert">Alert</option> */}
                        </select>
                    </div>
                    <div className='mt-3'>
                        {optiontype} 
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-12 label">Question Order:</label>
                        <input type="number"  value={questionOrder} onChange={(e)=>setQuestionOrder(e.target.value)} />
                        {/* <select className="form-select col-sm-5 selectBox" value={questionOrder} onChange={(e)=>setQuestionOrder(e.target.value)} >
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                        </select> */}
                    </div>
                    <div className="form-group">
                        <div className="col-sm-offset-2 col-sm-10">
                            <button type="submit" className="btn btn-default submitBtn">Submit</button>
                        </div>
                    </div>
                </form>
                {
                        successMessages.map((message, index) => (
                            <SuccessMessage
                                key={index} 
                                message = {message} 
                                onFadeOut={handleSuccessMessageFadeOut}
                            />
                        )
                    )
                }
            </div>
        </div>
    )
}

export default Editquiz;